module.exports = __webpack_public_path__ + "media/8.f367b7e1.mp3";